import arrowRightImage from "@images/arrowRight.svg";
import { Box, Modal, Typography } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { ReactComponent as LogoIcon } from "@icons/logo-light.svg";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { COLORS } from "../../theme/constants";

const DATA = {
  instagram: [
    "데이터 이관을 위한 계정은 공개 상태의 계정이어야 하며, 비공개시 정상적인 데이터 이관이 이루어지지 않습니다.",
    "데이터 이관 작업이 완료되면 피카버스 푸시 알림 및 이메일로 완료 내역이 전달됩니다.",
    "데이터 이관 도중 피카버스 앱에 콘텐츠를 등록하면 이슈 발생 우려가 있으니 사용을 자제해주시기 바랍니다.",
    "본인의 계정이 아닌 타인의 인스타그램 계정을 무단으로 데이터 이관시 콘텐츠 무단 도용 관련 법령에 따라 처벌을 받을 수 있습니다.",
  ],
  youtube: [
    "공개로 설정된 영상만 데이터가 이관되며, 비공개 설정된 영상은 이관되지 않습니다.",
    "데이터 이관 작업이 완료되면 피카버스 푸시 알림 및 이메일로 완료 내역이 전달됩니다.",
    "데이터 이관 도중 피카버스 앱에 콘텐츠를 등록하면 이슈 발생 우려가 있으니 사용을 자제해주시기 바랍니다. ",
    "본인의 계정이 아닌 타인의 유튜브 계정을 무단으로 데이터 이관시 콘텐츠 무단 도용 관련 법령에 따라 처벌을 받을 수 있습니다.",
  ],
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(100% - 40px)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "16px",
  padding: "24px 20px",
  textAlign: "center",
};

const styleError = {
  fontWeight: "400",
  fontSize: "10px",
  lineHeight: "16px",
  color: `${COLORS.redError}`,
  whiteSpace: "pre-line",
};

const Dot = () => {
  return (
    <div
      style={{
        width: "4px",
        minWidth: "4px",
        height: "4px",
        borderRadius: "4px",
        backgroundColor: "#3B3B3B",
        margin: "6px",
        marginLeft: 0,
      }}
    ></div>
  );
};

const Radio = ({ value, onChange, label }) => {
  // const [value, setChecked] = useState(false);
  return (
    <div onClick={onChange} style={{ cursor: "pointer", display: "flex", gap: "8px" }}>
      <div
        style={{
          width: "24px",
          height: "24px",
          borderRadius: "12px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#FFF",
          border: "2px solid #D9D9D9",
          borderColor: value ? "#1E1E1E" : "#D9D9D9",
        }}
      >
        <div
          style={{
            width: "12px",
            height: "12px",
            borderRadius: "6px",
            backgroundColor: value ? "#1E1E1E" : "",
          }}
        ></div>
      </div>

      <p
        style={{
          fontSize: "14px",
          lineHeight: "18px",
          fontWeight: 500,
          marginTop: "3px",
        }}
      >
        {label}
      </p>
    </div>
  );
};
const Register = ({ nextStep, preStep, changeType, userData, handleOk }) => {
  const [open, setOpen] = useState(false);
  // const schema = yup
  // .object({
  //   url: yup.string().when("type", (type, schema) => {
  //     if(type === "youtube")
  //       return schema.required("Must enter email address")
  //     return schema
  //   }),
  // })

  const {
    register,
    handleSubmit,
    setValue,
    getValues,

    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      type: "instagram",
      address: "",
    },
    // resolver: yupResolver(schema),
    // mode: "onChange",
  });

  const onSubmit = (data) => {
    setOpen(true);
  };

  const handleChangeRadio = (value) => () => {
    setValue("type", value, {
      shouldValidate: true,
    });
  };

  return (
    <div style={{ backgroundColor: "#EBEBEB", height: "100%" }}>
      <div
        style={{
          margin: "auto",
          backgroundColor: "white",
          wordBreak: "keep-all",
          color: "#1E1E1E",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <div
          style={{
            padding: "16px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <div className='icon-wrap' onClick={preStep}>
            <img
              src={arrowRightImage}
              style={{
                transform: "rotate(180deg)",
                width: "24px",
                height: "24px",
              }}
            />
          </div>

          <div style={{ flex: 1, textAlign: "center" }}>
            <p
              style={{
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: "24px",
              }}
            >
              데이터 이관 신청하기
            </p>
          </div>

          <div
            style={{
              width: "24px",
              height: "24px",
            }}
          ></div>
        </div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{ display: "flex", flexDirection: "column", flex: 1 }}
        >
          <div style={{ flex: 1 }}>
            <div style={{ padding: "24px 20px" }}>
              <div style={{ display: "flex", gap: "32px", marginBottom: "24px" }}>
                <Radio
                  value={getValues("type") === "instagram"}
                  onChange={handleChangeRadio("instagram")}
                  label='인스타그램'
                />

                <Radio
                  value={getValues("type") === "youtube"}
                  onChange={handleChangeRadio("youtube")}
                  label='유튜브'
                />
              </div>
              <div>
                <p
                  style={{
                    fontSize: "14px",
                    lineHeight: "18px",
                    fontWeight: 500,
                  }}
                >
                  {/* {getValues("type") === "instagram" ? "인스타그램 계정 주소" : "유튜브 계정 주소"} */}
                  {getValues("type") === "youtube" && "유튜브 계정 주소"}
                </p>

                {getValues("type") === "youtube" && (
                  <>
                    <input
                      style={{
                        padding: "12px",
                        borderRadius: "8px",
                        border: "1px solid #D9D9D9",
                        width: "100%",
                        marginTop: "6px",
                      }}
                      placeholder={
                        getValues("type") === "instagram"
                          ? "https://instagram.com/picaverse"
                          : "https://youtube.com/picaverse"
                      }
                      {...register("url", {
                        required: true,
                        pattern: {
                          value: /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/i,
                          message: "잘못된 유튜브 링크",
                        },
                      })}
                    />
                    {errors.url && (
                      <Typography style={styleError}>{errors["url"]?.message}</Typography>
                    )}
                  </>
                )}
              </div>

              {/* <div
                style={{
                  marginTop: "12px",
                  borderRadius: "8px",
                  padding: "16px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: 500,
                  color: "#FFF",
                  backgroundColor: "#1E1E1E",
                  width: "100%",
                }}
                onClick={() => {
                  if (getValues("address")) {
                    setOpen("verify");
                  }
                }}
              >
                인증하기
              </div> */}
            </div>

            <div style={{ padding: "0 20px" }}>
              <div
                style={{
                  backgroundColor: "#F5F5F5",
                  borderRadius: "8px",
                  padding: "20px 16px",
                  fontSize: "12px",
                  lineHeight: "16px",
                  fontWeight: 400,
                  color: "#3B3B3B",
                }}
              >
                {DATA[getValues("type")]?.map((item, index) => (
                  <div key={index} style={{ display: "flex", marginTop: "8px" }}>
                    <Dot />
                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div style={{ padding: "20px" }}>
            <button
              type='submit'
              style={{
                marginTop: "12px",
                borderRadius: "8px",
                padding: "16px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: 500,
                color: isValid || getValues("type") === "instagram" ? "#FFF" : "#707070",
                backgroundColor:
                  isValid || getValues("type") === "instagram" ? "#1E1E1E" : "#EBEBEB",
                width: "100%",
              }}
              //   onClick={() => setOpen(true)}
            >
              확인
            </button>
          </div>
        </form>
      </div>
      <Modal
        open={!!open}
        onClose={() => setOpen(false)}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          {open === "verify" ? (
            <>
              {" "}
              <Typography
                id='modal-modal-title'
                variant='h6'
                component='h2'
                style={{
                  fontSize: "16px",
                  fontWeight: 700,
                  lineHeight: "24px",
                }}
              >
                인증실패
              </Typography>
              <Typography
                id='modal-modal-description'
                sx={{
                  mt: "16px",
                  fontSize: "14px",
                  lineHeight: "22px",
                  fontWeight: 400,
                }}
              >
                인스타그램 인증이 정상적으로 완료되지 않았습니다. <br />
                고객센터에 문의하세요.
              </Typography>
              <Typography
                sx={{
                  mt: "24px",
                  borderRadius: "8px",
                  padding: "12px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: 500,
                  color: "#FFF",
                  backgroundColor: "#1E1E1E",
                  width: "100%",
                }}
                onClick={() => setOpen(false)}
              >
                확인
              </Typography>
            </>
          ) : (
            <>
              <Typography
                id='modal-modal-title'
                variant='h6'
                component='h2'
                style={{
                  fontSize: "16px",
                  fontWeight: 700,
                  lineHeight: "20px",
                  color: COLORS.black1
                }}
              >
                {getValues("type") === "instagram" ? "인스타그램 데이터 이관" : "유튜브 데이터 이관"}
              </Typography>
              <Typography
                id='modal-modal-description'
                sx={{
                  mt: "28px",
                  fontSize: "16px",
                  lineHeight: "20px",
                  fontWeight: 700,
                  color: "#555",
                }}
              >
                {getValues("type") === "instagram" ? (
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='93'
                    height='27'
                    viewBox='0 0 93 27'
                    fill='none'
                  >
                    <path
                      d='M4.78642 0.0946692C2.88294 0.910102 0.790395 3.2138 0.129499 6.10544C-0.707474 9.76927 2.77556 11.3186 3.06124 10.8106C3.39748 10.2137 2.43712 10.0118 2.23944 8.11086C1.98395 5.65561 3.09926 2.91214 4.50292 1.70839C4.76384 1.48474 4.75143 1.79602 4.75143 2.37179C4.75143 3.4014 4.69584 12.6443 4.69584 14.5733C4.69584 17.1834 4.5905 18.0077 4.4013 18.8221C4.20961 19.6475 3.90143 20.2052 4.13495 20.42C4.39586 20.6603 5.50982 20.0887 6.15471 19.1676C6.92803 18.0628 7.19872 16.736 7.24733 15.2952C7.30603 13.5583 7.30352 10.8021 7.30603 9.23008C7.30837 7.78826 7.32976 3.5663 7.28133 1.02821C7.26946 0.405669 5.58246 -0.247468 4.78632 0.0939119L4.78642 0.0946692ZM72.3786 12.3101C72.3173 13.667 72.0238 14.7277 71.6595 15.4758C70.9543 16.9242 69.491 17.3739 68.8697 15.2918C68.5312 14.1569 68.5153 12.2615 68.7588 10.6777C69.0066 9.06431 69.6984 7.84583 70.8441 7.95571C71.9741 8.06434 72.5031 9.5546 72.3786 12.3101ZM53.3283 20.729C53.313 22.9837 52.9663 24.9606 52.2227 25.5348C51.1682 26.3489 49.7507 25.7382 50.0442 24.0929C50.3039 22.637 51.5321 21.1502 53.3313 19.3335C53.3313 19.3335 53.335 19.7478 53.3283 20.729ZM53.0403 12.2969C52.9758 13.5329 52.6628 14.7745 52.3212 15.476C51.6162 16.9243 50.1422 17.3771 49.5314 15.292C49.1138 13.8674 49.2138 12.0236 49.4205 10.8618C49.6886 9.35444 50.3385 7.95604 51.5058 7.95604C52.6407 7.95604 53.2003 9.23019 53.0403 12.2969ZM42.0045 12.278C41.9353 13.587 41.6857 14.6812 41.2853 15.476C40.5609 16.9144 39.1277 17.3705 38.4956 15.292C38.0399 13.7932 38.195 11.7496 38.3846 10.6457C38.6659 9.00745 39.3703 7.84598 40.4699 7.95604C41.5995 8.06898 42.1486 9.5546 42.0045 12.278ZM92.5793 13.807C92.3032 13.807 92.1772 14.0983 92.0729 14.5886C91.7113 16.2935 91.3312 16.6784 90.8411 16.6784C90.2936 16.6784 89.8016 15.8342 89.6751 14.1443C89.5757 12.8155 89.5917 10.3692 89.7188 7.9357C89.7448 7.43572 89.61 6.94102 88.2996 6.45384C87.7358 6.24429 86.9162 5.93574 86.5081 6.9439C85.355 9.79212 84.9039 12.0534 84.7978 12.972C84.7923 13.0195 84.7353 13.0292 84.7253 12.9182C84.6577 12.1824 84.5065 10.8455 84.4877 8.03648C84.4841 7.48843 84.3706 7.02192 83.7795 6.63999C83.396 6.39217 82.2314 5.95386 81.812 6.4753C81.4487 6.90177 81.028 8.04945 80.5908 9.40989C80.2354 10.5156 79.9879 11.2636 79.9879 11.2636C79.9879 11.2636 79.9926 8.28015 79.9969 7.14848C79.9987 6.72154 79.7126 6.57928 79.6264 6.55349C79.238 6.43814 78.4728 6.24542 78.148 6.24542C77.7473 6.24542 77.6492 6.47467 77.6492 6.80869C77.6492 6.85242 77.5859 10.7367 77.5859 13.4527C77.5859 13.5707 77.5859 13.6994 77.5871 13.8362C77.3654 15.0845 76.6466 16.7791 75.8649 16.7791C75.0822 16.7791 74.713 16.0706 74.713 12.8327C74.713 10.9437 74.7684 10.1224 74.7956 8.75617C74.8114 7.96926 74.8419 7.36497 74.8402 7.22784C74.8345 6.80731 74.1239 6.59536 73.7933 6.51703C73.4612 6.43804 73.1725 6.40744 72.9471 6.42058C72.6281 6.439 72.4024 6.6532 72.4024 6.94781C72.4024 7.10576 72.4041 7.40614 72.4041 7.40614C71.9932 6.74531 71.3323 6.28537 70.8926 6.15208C69.7083 5.79211 68.4724 6.11107 67.5403 7.44604C66.7994 8.50674 66.3528 9.70809 66.177 11.4341C66.0485 12.696 66.0904 13.9756 66.3188 15.0577C66.0429 16.2788 65.5305 16.7791 64.9695 16.7791C64.1551 16.7791 63.5646 15.4186 63.6332 13.0656C63.6784 11.518 63.981 10.4319 64.3117 8.86062C64.4528 8.19081 64.3382 7.84013 64.0508 7.50402C63.7872 7.1958 63.2256 7.03832 62.4181 7.23201C61.843 7.3701 61.0208 7.5186 60.2684 7.63267C60.2684 7.63267 60.3138 7.44731 60.3511 7.12051C60.5468 5.40667 58.727 5.54572 58.1465 6.09313C57.7999 6.41994 57.564 6.80539 57.4745 7.49842C57.3325 8.59822 58.2089 9.11695 58.2089 9.11695C57.9214 10.4641 57.2165 12.2239 56.4887 13.4962C56.099 14.1779 55.8008 14.683 55.4159 15.22C55.4145 15.02 55.4134 14.8201 55.4127 14.6211C55.4039 11.7889 55.4407 9.55985 55.457 8.75644C55.4728 7.96953 55.5036 7.38127 55.5019 7.24413C55.4976 6.93655 55.322 6.8204 54.957 6.67333C54.6342 6.54325 54.2526 6.45322 53.8567 6.42182C53.3571 6.38193 53.0561 6.65315 53.0639 6.97387C53.0654 7.03443 53.0654 7.40626 53.0654 7.40626C52.6545 6.74542 51.9936 6.28549 51.5539 6.15219C50.3696 5.79238 49.1337 6.11134 48.2015 7.44615C47.4608 8.50685 46.9757 9.99528 46.8383 11.4211C46.7102 12.7499 46.7339 13.8792 46.9084 14.8305C46.7201 15.7831 46.1787 16.7792 45.5664 16.7792C44.7838 16.7792 44.3384 16.0707 44.3384 12.8328C44.3384 10.9438 44.3938 10.1225 44.4211 8.75644C44.4369 7.96953 44.4674 7.36509 44.4657 7.22812C44.4599 6.80759 43.7494 6.59564 43.4188 6.51714C43.0728 6.43528 42.7742 6.40516 42.5448 6.42245C42.2423 6.44553 42.0295 6.72284 42.0295 6.92966V7.40626C41.6186 6.74542 40.9577 6.28549 40.518 6.15219C39.3337 5.79238 38.1047 6.11648 37.1657 7.44615C36.5533 8.31316 36.0576 9.27438 35.8024 11.4022C35.7287 12.0171 35.6961 12.5929 35.7004 13.1311C35.4562 14.6595 34.3776 16.421 33.4954 16.421C32.9792 16.421 32.4875 15.3962 32.4875 13.2121C32.4875 10.3029 32.6634 6.16069 32.6932 5.76147C32.6932 5.76147 33.8078 5.74208 34.0237 5.73951C34.5797 5.73326 35.0833 5.74672 35.8239 5.70795C36.1953 5.68857 36.5532 4.32429 36.1698 4.15544C35.9961 4.07902 34.768 4.01206 34.2812 4.00149C33.8719 3.99199 32.7323 3.90568 32.7323 3.90568C32.7323 3.90568 32.8345 1.15629 32.8583 0.865854C32.8785 0.623786 32.5725 0.499153 32.397 0.423527C31.9703 0.238819 31.5885 0.150382 31.136 0.0549032C30.5108 -0.0770967 30.2271 0.0520193 30.1717 0.59206C30.0883 1.41166 30.0451 3.81228 30.0451 3.81228C29.5863 3.81228 28.019 3.72049 27.5601 3.72049C27.1337 3.72049 26.6735 5.59726 27.263 5.62032C27.9412 5.64724 29.1232 5.67047 29.9068 5.69466C29.9068 5.69466 29.8719 9.90509 29.8719 11.205C29.8719 11.3433 29.8731 11.4764 29.8734 11.6057C29.4421 13.9062 27.9231 15.1489 27.9231 15.1489C28.2493 13.6269 27.5829 12.4841 26.3826 11.5166C25.9404 11.1601 25.0674 10.4852 24.0906 9.74556C24.0906 9.74556 24.6564 9.17492 25.1581 8.02692C25.5135 7.21373 25.5289 6.28311 24.6564 6.0779C23.2147 5.73859 22.0259 6.82219 21.6714 7.97902C21.3967 8.87518 21.5432 9.54018 22.0814 10.231C22.1207 10.2814 22.1632 10.333 22.2072 10.3849C21.8818 11.0269 21.4347 11.8912 21.0561 12.5614C20.0051 14.4223 19.2111 15.8943 18.6111 15.8943C18.1315 15.8943 18.1379 14.3999 18.1379 13.0007C18.1379 11.7945 18.225 9.98105 18.2945 8.10349C18.3175 7.48255 18.0141 7.12882 17.5055 6.80842C17.1965 6.61377 16.537 6.23105 16.1551 6.23105C15.5834 6.23105 13.934 6.31067 12.3756 10.9243C12.1792 11.5058 11.7933 12.5654 11.7933 12.5654L11.8265 7.01732C11.8265 6.88724 11.7588 6.76148 11.6038 6.67544C11.3412 6.5295 10.6398 6.23105 10.0161 6.23105C9.71894 6.23105 9.57065 6.37251 9.57065 6.65446L9.51625 15.3345C9.51625 15.9941 9.53305 16.7634 9.59676 17.1C9.66024 17.4369 9.76308 17.711 9.89045 17.8741C10.0176 18.0368 10.1648 18.161 10.4073 18.2122C10.6331 18.2598 11.8693 18.4223 11.9335 17.9388C12.0105 17.3594 12.0135 16.7326 12.6626 14.3953C13.6732 10.7563 14.9907 8.98075 15.6101 8.3502C15.7184 8.23999 15.8421 8.23341 15.8361 8.41379C15.8097 9.21161 15.7167 11.2052 15.6541 12.8988C15.4863 17.4313 16.292 18.2713 17.4433 18.2713C18.3241 18.2713 19.5658 17.3757 20.8968 15.1083C21.7266 13.6954 22.5323 12.3099 23.1111 11.3114C23.5145 11.6936 23.9672 12.1049 24.4196 12.5443C25.4709 13.5655 25.816 14.5358 25.587 15.4563C25.4119 16.16 24.7522 16.8852 23.5782 16.1803C23.236 15.9747 23.09 15.8158 22.7459 15.584C22.5611 15.4594 22.2788 15.4222 22.1096 15.5527C21.6701 15.8918 21.4187 16.3233 21.2751 16.8574C21.1355 17.3771 21.6441 17.6518 22.1713 17.8921C22.6252 18.0989 23.6009 18.2864 24.2231 18.3077C26.6476 18.3907 28.5897 17.1097 29.9417 13.8054C30.1837 16.6591 31.2137 18.2739 33.0032 18.2739C34.1996 18.2739 35.3991 16.6912 35.9237 15.1343C36.0742 15.7689 36.2971 16.3208 36.585 16.7875C37.9639 19.0235 40.639 18.5422 41.9827 16.6436C42.3981 16.0569 42.4613 15.8461 42.4613 15.8461C42.6573 17.6389 44.068 18.2653 44.8757 18.2653C45.7803 18.2653 46.7144 17.8276 47.369 16.3193C47.4457 16.483 47.5295 16.6393 47.6209 16.7875C48.9998 19.0234 51.6748 18.5422 53.0185 16.6435C53.0819 16.5544 53.1369 16.4737 53.1849 16.4011L53.2244 17.5787C53.2244 17.5787 52.4578 18.2984 51.9873 18.7399C49.9163 20.6844 48.3416 22.1597 48.2257 23.8777C48.077 26.0683 49.813 26.8825 51.1263 26.9892C52.521 27.1025 53.7154 26.314 54.4496 25.2105C55.0953 24.2392 55.5179 22.1487 55.4869 20.084C55.4745 19.2572 55.4542 18.2059 55.4382 17.0791C56.1661 16.214 56.9862 15.1206 57.7413 13.8408C58.5642 12.446 59.4461 10.573 59.8977 9.11528C59.8977 9.11528 60.664 9.12201 61.4817 9.06722C61.7433 9.04976 61.8184 9.10438 61.7701 9.30064C61.7117 9.53773 60.7369 13.3855 61.6265 15.9487C62.2354 17.7034 63.6081 18.2679 64.4219 18.2679C65.3746 18.2679 66.2859 17.5316 66.7743 16.4383C66.8332 16.5602 66.8947 16.6781 66.9619 16.787C68.3408 19.023 71.0064 18.5388 72.3595 16.643C72.6649 16.2153 72.8382 15.8455 72.8382 15.8455C73.1285 17.701 74.5385 18.2742 75.346 18.2742C76.1872 18.2742 76.9856 17.9212 77.6333 16.3527C77.6604 17.0433 77.703 17.6081 77.7703 17.7861C77.8113 17.895 78.0503 18.0317 78.2242 18.0977C78.9937 18.3897 79.7786 18.2516 80.069 18.1915C80.2701 18.1499 80.427 17.9847 80.4484 17.5582C80.5048 16.4384 80.4702 14.557 80.8019 13.1588C81.3587 10.8121 81.8781 9.90187 82.1245 9.45123C82.2624 9.19874 82.418 9.15709 82.4236 9.42431C82.4352 9.96499 82.4615 11.5528 82.6772 13.686C82.8356 15.2549 83.0472 16.1823 83.2098 16.4758C83.674 17.3151 84.2472 17.3548 84.714 17.3548C85.0109 17.3548 85.6319 17.2708 85.5764 16.7367C85.5493 16.4764 85.5967 14.8675 86.1457 12.5556C86.5041 11.0459 87.1018 9.68173 87.3173 9.18303C87.3969 8.99912 87.4338 9.1441 87.4325 9.17234C87.3871 10.2121 87.2852 13.6128 87.6991 15.4728C88.2601 17.9924 89.8831 18.2744 90.4487 18.2744C91.656 18.2744 92.6434 17.3344 92.9761 14.8613C93.0562 14.2661 92.9376 13.8065 92.5821 13.8065'
                      fill='#262626'
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='92'
                    height='20'
                    viewBox='0 0 92 20'
                    fill='none'
                  >
                    <path
                      d='M15.9445 19.9744L10.0488 19.8658C8.1398 19.8281 6.22615 19.9036 4.35471 19.5119C1.50769 18.9268 1.306 16.0576 1.09494 13.651C0.804139 10.2675 0.916707 6.82264 1.46547 3.46746C1.77503 1.58459 2.99452 0.461478 4.88003 0.338785C11.2448 -0.104797 17.6518 -0.0528882 24.0025 0.154746C24.6732 0.173622 25.3486 0.277439 26.0099 0.395413C29.2744 0.971126 29.3541 4.22249 29.5652 6.95949C29.7762 9.7248 29.6871 12.5043 29.2838 15.2507C28.9601 17.5252 28.341 19.4317 25.7285 19.6157C22.4546 19.8564 19.2558 20.0499 15.9726 19.9885C15.9726 19.9744 15.9539 19.9744 15.9445 19.9744ZM12.4783 14.2172C14.9454 12.7921 17.3657 11.3906 19.8187 9.9749C17.3469 8.54977 14.9314 7.14824 12.4783 5.73256V14.2172Z'
                      fill='#FF0000'
                    />
                    <path
                      d='M77.0078 17.3882C76.8952 17.8506 76.7967 18.214 76.6982 18.6009H74.3906V0.692486H77.0828V7.29903C77.2235 7.11971 77.2939 7.0442 77.3549 6.96398C77.8145 6.32692 78.4102 5.91165 79.1794 5.75121C80.4036 5.51054 81.4495 6.05322 81.82 7.23768C82.0592 7.97384 82.214 8.7619 82.2328 9.53109C82.2703 11.5083 82.2422 13.4809 82.1718 15.4581C82.1437 16.0621 81.9607 16.6803 81.7309 17.2466C80.9758 19.1153 78.5087 19.3984 77.2845 17.7798C77.2094 17.6807 77.1391 17.5722 77.0078 17.3882ZM77.1391 15.7365C77.1391 16.2698 77.4205 16.5954 77.9505 16.7181C78.4711 16.8408 78.8933 16.6378 79.1043 16.1518C79.1935 15.9489 79.2826 15.7365 79.2873 15.5242C79.3389 13.5233 79.3858 11.5225 79.3998 9.51694C79.3998 9.14414 79.3107 8.75718 79.1981 8.39382C78.9871 7.73789 78.4055 7.54441 77.8333 7.92665C77.4017 8.21922 77.1391 8.63449 77.1391 9.18661V15.7365ZM69.8222 6.00603H72.6411V18.6104H70.4413C70.3616 18.1338 70.2818 17.643 70.188 17.0673C70.0379 17.2891 69.9488 17.4306 69.855 17.5722C69.1233 18.634 68.0868 18.9973 66.8626 18.8038C65.8167 18.634 65.1882 17.8223 65.0475 16.4916C65.0052 16.0952 64.9865 15.6941 64.9865 15.2977C64.9771 12.3483 64.9865 9.38952 64.9865 6.44018V5.99659H67.8382V6.51096C67.8382 9.36121 67.8288 12.2067 67.8476 15.057C67.8476 15.4628 67.8898 15.8828 67.9601 16.2886C68.0399 16.7039 68.3401 16.8549 68.7434 16.8266C69.3954 16.7747 69.8456 16.2886 69.8456 15.6374V6.56287C69.8222 6.37883 69.8222 6.20895 69.8222 6.00603ZM50.4137 5.99659H53.2466V6.52984C53.2466 9.36593 53.2372 12.1973 53.256 15.024C53.256 15.4298 53.2935 15.8498 53.3779 16.2462C53.4858 16.7133 53.7579 16.8644 54.2222 16.803C54.8648 16.7133 55.2541 16.265 55.2587 15.6091V6.01547H58.0776V18.6104H55.8873C55.8075 18.1432 55.7278 17.6619 55.6246 17.0531C55.4839 17.2655 55.4041 17.3882 55.3244 17.5156C54.5927 18.5962 53.5655 18.9926 52.3132 18.7991C51.3095 18.6481 50.6951 17.9025 50.5075 16.6803C50.4559 16.2981 50.4183 15.9206 50.4183 15.5383C50.409 12.4757 50.409 9.39896 50.409 6.33636L50.4137 5.99659ZM48.9596 12.7258C48.9503 13.1505 48.9221 13.5752 48.8987 13.9999C48.7908 15.2741 48.7392 17.0814 47.7167 18.0111C47.0648 18.5962 46.2393 18.8086 45.3856 18.8369C45.0057 18.8463 44.6211 18.8463 44.2412 18.7944C42.4448 18.5207 41.6099 17.7232 41.3097 15.7365C40.9673 13.4431 40.9392 11.1119 41.3473 8.81853C41.7694 6.44489 43.2234 5.60492 45.4841 5.76065C47.5948 5.91165 48.5375 7.30374 48.7861 9.28571C48.9221 10.423 48.9878 11.5744 48.9596 12.7258ZM46.0892 12.2917C46.0892 11.4847 46.1079 10.6731 46.0798 9.86614C46.061 9.39896 46.0001 8.92707 45.9016 8.46461C45.789 7.93137 45.4513 7.67654 45.0292 7.68598C44.6164 7.69542 44.3256 7.95024 44.1755 8.44573C44.1239 8.62977 44.0676 8.81853 44.0676 9.00257C44.0676 10.2673 44.0583 11.5366 44.0489 12.8013C44.0395 13.9811 43.8894 15.2174 44.2599 16.3453C44.3725 16.6898 44.6633 16.8785 45.0432 16.8785C45.4138 16.8785 45.6577 16.6945 45.7937 16.3641C45.9016 16.1093 45.9954 15.8309 45.9954 15.5572C46.0282 14.4718 46.0892 13.3818 46.0892 12.2917ZM37.1729 9.91805C37.4215 8.69584 37.656 7.50194 37.9139 6.30333C38.2376 4.7791 38.5987 3.25488 38.9177 1.72594C38.9974 1.35314 39.1475 1.26348 39.4993 1.27292C40.2544 1.30123 41.0236 1.28236 41.8304 1.28236C41.5677 2.25446 41.3097 3.17938 41.0565 4.09014C40.2544 6.94982 39.4524 9.81895 38.6597 12.6881C38.5987 12.9099 38.5706 13.1505 38.5706 13.3865C38.5612 14.9532 38.5706 16.5151 38.5706 18.0818V18.5915H35.8174C35.808 18.4499 35.7892 18.3084 35.7892 18.1668C35.7892 17.2796 35.7189 16.3877 35.7986 15.51C36.0003 13.4006 35.3343 11.4611 34.7949 9.49806C34.082 6.90263 33.3596 4.29777 32.6467 1.70234C32.6092 1.57965 32.5951 1.44752 32.5576 1.29651H35.3671C35.9581 4.16092 36.5538 7.02533 37.1729 9.91805ZM91.0412 13.2072H86.2946C86.3462 14.1651 86.365 15.0759 86.4635 15.9772C86.5338 16.6048 86.8762 16.8738 87.4156 16.8785C87.9784 16.8879 88.3067 16.6048 88.4381 15.9819C88.4803 15.779 88.5084 15.5761 88.5272 15.3684C88.546 15.1844 88.5553 14.9862 88.5694 14.7219C89.3715 14.7644 90.1547 14.8116 90.9286 14.8446C91.3789 16.1895 90.5675 17.9167 89.2026 18.4499C88.1285 18.8746 87.0263 18.8746 85.9288 18.549C85.1173 18.3084 84.5123 17.7893 84.2402 16.9918C83.987 16.2462 83.7478 15.4675 83.6962 14.6889C83.5555 12.7683 83.5039 10.8288 83.7947 8.90347C83.8463 8.58258 83.9354 8.27585 84.0339 7.9644C84.4279 6.68084 85.2862 5.89278 86.6135 5.76065C87.3359 5.68986 88.0816 5.71818 88.7945 5.84087C89.9484 6.04378 90.5628 6.87904 90.8301 7.97384C90.9521 8.4882 91.0412 9.01673 91.06 9.54053C91.0647 10.7439 91.0412 11.9378 91.0412 13.2072ZM88.3443 11.5508C88.3443 10.6023 88.3537 9.71041 88.3349 8.81381C88.3349 8.60146 88.2552 8.37967 88.1754 8.17675C88.016 7.78036 87.6829 7.67182 87.2843 7.67182C86.8856 7.67182 86.6323 7.87474 86.5338 8.2381C86.2336 9.32818 86.3321 10.4419 86.3415 11.5602C87.0591 11.5508 87.7111 11.5508 88.3443 11.5508Z'
                      fill='#282828'
                    />
                    <path
                      d='M60.2539 3.59462H57.4631V1.32008H65.7931V3.58046H63.0211V18.5915H60.2585L60.2539 3.59462Z'
                      fill='#282828'
                    />
                  </svg>
                )}

                {/* <p style={{ marginTop: "4px" }}>{}</p> */}

                <div style={{ margin: "12px 0" }}>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='21'
                    viewBox='0 0 20 21'
                    fill='none'
                  >
                    <path
                      d='M2 7L10 13L18 7'
                      stroke='#D0D5DD'
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M2 1L10 6L18 1'
                      stroke='#EAECF0'
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M2 14L10 19L18 14'
                      stroke='#98A2B3'
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                </div>

                {/* <img src="/assets/svgs/logo-dark.svg" alt="" /> */}
                <LogoIcon style={{ height: "15px" }} />

                <p style={{ marginTop: "10px" }}>{userData?.nickname}</p>

                <p
                  style={{
                    marginTop: "28px",
                    fontSize: "14px",
                    lineHeight: "18px",
                    fontWeight: 400,
                    color: "#1E1E1E",
                  }}
                >
                  데이터 이관을 신청하시겠습니까?
                </p>
              </Typography>
              <Typography
                sx={{
                  mt: "24px",
                  width: "100%",
                  display: "flex",
                  gap: "8px",
                }}
              >
                <div
                  style={{
                    borderRadius: "8px",
                    padding: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: 500,
                    color: "#707070",
                    backgroundColor: "#EBEBEB",
                    flex: 1,
                  }}
                  onClick={() => setOpen(false)}
                >
                  취소
                </div>
                <div
                  style={{
                    borderRadius: "8px",
                    padding: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: 500,
                    color: "#FFF",
                    backgroundColor: "#1E1E1E",
                    flex: 1,
                  }}
                  onClick={() => {
                    setOpen(false);
                    handleOk(getValues("type"), getValues("url"));
                  }}
                >
                  확인
                </div>
              </Typography>
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default Register;
